
import { PrivacyAndTermsActions, PrivacyAndTermsActionTypes } from '../actions/privacy-and-terms.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: {
    privacy: string,
    terms: string
  };
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: {
    privacy: '',
    terms: ''
  }
};

export function reducer(state = initialState, action: PrivacyAndTermsActions): State {
  switch (action.type) {
    case PrivacyAndTermsActionTypes.GetPrivacyAndTerms:
      return {...state, Loaded: false, Loading: true};

    case PrivacyAndTermsActionTypes.LoadPrivacyAndTermss:
      return {...state, Loaded: true, Loading: false, entities: {privacy: action.payload.privacy, terms: action.payload.terms}};

    case PrivacyAndTermsActionTypes.GetPrivacyAndTermsFail:
      return {...state, Loaded: true, Loading: false};

    default:
      return state;
  }
}
